var map = {
	"./AbbyTiny Logger's Axe.png": 30823,
	"./AdamZroa Yeshana.png": 11987,
	"./AgielbaThunder Dirk Jove.png": 46170,
	"./Aglovale and TorWales Pennant.png": 25326,
	"./AglovaleFrostbloom Fan.png": 12684,
	"./AglovaleGottfried.png": 88014,
	"./AglovaleWales' Finest.png": 72710,
	"./AlbertHauteclaire.png": 95792,
	"./AlbertSchwarz Lightning.png": 94219,
	"./AlbertSurviving Lightning.png": 88258,
	"./AlchemistFaust.png": 35820,
	"./AletheiaGreatsword Andalius.png": 63987,
	"./AletheiaShroudsword Verveine.png": 91674,
	"./AlexielMirror-Blade Shard.png": 30927,
	"./AlexielNibelung Glas.png": 2538,
	"./AlizaMagma Gauntlet.png": 34741,
	"./AlizaSunset Blaze.png": 27148,
	"./AlliahDowry Blade.png": 93457,
	"./AltairDainsleif.png": 36811,
	"./AltairWar Fan of Secret Teachings.png": 23720,
	"./AmeliaShining Silver.png": 82921,
	"./AmiraDragon Slayer.png": 12608,
	"./AmiraSummer Genesis.png": 40592,
	"./AndersonBlade of Loyalty.png": 77212,
	"./AndiraDormius.png": 65005,
	"./AndiraNinth Head of the Cartload.png": 64385,
	"./AnilaEighth Point of the Flock.png": 522,
	"./AnilaEighth Shear of the Flock.png": 65193,
	"./AnilaRamulus.png": 50327,
	"./AnnaCloudblazer's Broom.png": 25039,
	"./AnneCodex of Mysteria.png": 1603,
	"./AnneDaemon's Spine.png": 32920,
	"./AnreOne-Rift Spear.png": 85948,
	"./AnthuriaForbidden Inferno.png": 95509,
	"./AnthuriaForbidden Memories.png": 10707,
	"./AnthuriaForbidden Silence.png": 51101,
	"./AoidosWay Flyer.png": 52125,
	"./ApsarasHelmwige.png": 43166,
	"./ArrietCords of Heaven Lyre.png": 21991,
	"./ArthurCollbrande.png": 67643,
	"./ArulumayaGargantua.png": 15866,
	"./ArulumayaPantagruel.png": 83941,
	"./ArulumayaStardust Holly Rod.png": 933,
	"./AssassinMisericorde.png": 36638,
	"./AthenaSacred Lance.png": 50209,
	"./AyerAncient Bandages.png": 98199,
	"./AzazelShadow Viperlance.png": 33781,
	"./AzazelTrick Serpent.png": 97372,
	"./AzusaDojigiri Yasutsuna.png": 55213,
	"./AzusaShishisosho.png": 57149,
	"./BaalSolomon's Accelerator.png": 86935,
	"./BaalSpymur's Clause.png": 99346,
	"./Bandit TycoonThe Storyteller.png": 38853,
	"./BaotordaSymbol of Justice.png": 89809,
	"./Barawa and SaryaLogic Breaker.png": 89114,
	"./BasaraCanifortis.png": 41041,
	"./BeatrixDelta Quartz.png": 40971,
	"./BeatrixEmbrasque Demiclone.png": 1337,
	"./BeatrixGram.png": 39589,
	"./BenjaminAtrocious Blood.png": 96292,
	"./BerserkerBerserker's Barrage.png": 14669,
	"./BishopNirvana.png": 18331,
	"./Black KnightBlutgang.png": 54493,
	"./BowmanImaginary Knuckles.png": 17098,
	"./CagliostroBlack Ouroboros.png": 22007,
	"./CagliostroOnly for a Cutie.png": 17808,
	"./CagliostroOuroboros Prime.png": 58231,
	"./CagliostroOuroboros Treat.png": 93250,
	"./CagliostroOuroboros.png": 78274,
	"./CainIchigo Hitofuri.png": 25529,
	"./CainStrawberry Slasher.png": 13949,
	"./CantateViolino della Memoria.png": 393,
	"./CarmelinaTurpin Spear.png": 87534,
	"./CaroTeardrop Mandolin.png": 4495,
	"./CassiusMaritozzo.png": 90385,
	"./CatherineArsene.png": 53878,
	"./CatherineNight Rider.png": 99372,
	"./CaturaBovinius.png": 3590,
	"./CaturaSecond Boss of the Herd.png": 60793,
	"./CavalierMezieres.png": 43922,
	"./CavalierVanguard.png": 89968,
	"./CendrillonLame d'ourlet.png": 7748,
	"./CerberusCoco & Mimi.png": 59104,
	"./Chaos RulerOriginal Sin.png": 3898,
	"./CharlottaClaidheamh Soluis.png": 5852,
	"./CharlottaClaíomh Solais Díon.png": 14987,
	"./CharlottaClaíomh Solais.png": 42137,
	"./CharlottaJack-O'-Brand.png": 81493,
	"./Chat NoirPhantom Thief Blade.png": 41462,
	"./CherineLourde et Courte.png": 61091,
	"./ChloeGlam Brush.png": 49445,
	"./ChristinaJewel Modele.png": 77701,
	"./ChrysaorWasserspeier.png": 52429,
	"./CidalaThird Stripe of the Streak.png": 72807,
	"./CidalaTigrisius.png": 80838,
	"./ClarisseFusion Mobius.png": 93194,
	"./ClarisseMobius Strip.png": 27876,
	"./ClarisseOcean's Klein.png": 90510,
	"./ClarisseSilphium.png": 43730,
	"./ClarisseSnowy Mobius Strip.png": 76514,
	"./ColossusMetal Destroyer.png": 84634,
	"./CosmosDiaitesia.png": 17378,
	"./CucourouxNaughty Witch.png": 56095,
	"./CucourouxVacation Toolbox.png": 55172,
	"./CucourouxWhite Hawk.png": 52922,
	"./CupitanRainbow Lyre.png": 2899,
	"./CupitanSea of Dreams.png": 54347,
	"./DancerArabesque.png": 49589,
	"./Dante and FreiheitNeko Punch Pro.png": 17440,
	"./DanteSpooky Mew.png": 74123,
	"./DanuaMikazuki.png": 11003,
	"./DanuaSnack Pole.png": 73698,
	"./DanuaSpectral Cleaver.png": 53588,
	"./Dark FencerIpetam.png": 40816,
	"./De La FilleDiamond Edge.png": 30788,
	"./De La FilleFleuret de Diamant.png": 28291,
	"./De La FilleKerykeion.png": 13428,
	"./De La FilleThyrsus.png": 98583,
	"./DelifordPiercing Momentum.png": 4529,
	"./DiabloBlack Claws.png": 40605,
	"./DianthaBrand New Melody.png": 38859,
	"./DianthaTlepilli.png": 69961,
	"./DoctorPsycho Syringe.png": 50635,
	"./Dorothy and ClaudiaGothic Cutlery.png": 54046,
	"./Dorothy and ClaudiaShine and Silence.png": 4263,
	"./DrangBlue Sphere.png": 33440,
	"./DrangRed Sphere.png": 6627,
	"./Drum MasterSoul Echoer.png": 58262,
	"./DrusillaLittle Vermilion.png": 44066,
	"./EahtaEight-Life Katana.png": 45026,
	"./EleaVergelmir.png": 68645,
	"./ElmottArson Blaze.png": 73207,
	"./ElmottSummer Night Blaze.png": 51119,
	"./ElysianChanteuse Angelique.png": 35299,
	"./EnyoGalvanic Lance.png": 54386,
	"./EnyoSplash Howl.png": 98123,
	"./ErikaHighland Cougar.png": 55697,
	"./ErinCrystal Edge.png": 55484,
	"./EugenAK-4A.png": 41341,
	"./EuropaCrystal Bellflowers.png": 12916,
	"./EuropaGalilei's Insight.png": 68748,
	"./EuropaSaintly Fountain.png": 70381,
	"./EustaceBubbleizer.png": 80127,
	"./EustaceIshtar.png": 50256,
	"./EustaceNightmare Mobilizer.png": 92519,
	"./EustaceStratomizer.png": 91547,
	"./EwiyarEvyg Em Noytnetta.png": 74719,
	"./EwiyarPiercing Galewing.png": 42443,
	"./Farrah and JuriBravery.png": 16535,
	"./FeatherHope-Filled Knuckles.png": 26195,
	"./FedielFediel Float.png": 82391,
	"./FedielSkeletal Eclipse.png": 10470,
	"./FeenaGreatbow Rondor.png": 32395,
	"./FeenaHeroic Bow.png": 90626,
	"./FeniePhoenix's Torch.png": 76991,
	"./FeowerDecorus Sicarius.png": 43075,
	"./FeowerFour-Sky Blade.png": 14247,
	"./FerryEthereal Lasher.png": 66646,
	"./FerryUnheil.png": 69226,
	"./FifFive-Soul Staff.png": 64826,
	"./FileneWhitefrost Glacier.png": 60708,
	"./FioritoBarbell.png": 65415,
	"./FioritoTraining Wreath.png": 49220,
	"./FlorenceDisturbance Signum.png": 31900,
	"./FlorenceFeast's Signum.png": 82793,
	"./FlorenceLunatum Psalterium.png": 14393,
	"./ForteSkyrend Spear.png": 34660,
	"./FreezieArachne.png": 30063,
	"./FreyrGullinbursti.png": 82871,
	"./GabrielGospel of Water and Sky.png": 24441,
	"./GalleonGalleon Float.png": 16731,
	"./GalleonLandslide Scepter.png": 56899,
	"./GawainTabarzin.png": 3279,
	"./GawainWindflash.png": 91510,
	"./GhandagozaBrahma Gauntlet.png": 88760,
	"./GladiatorProximo.png": 90560,
	"./GlorybringerRidill.png": 47051,
	"./Goblin MageShiny Cane.png": 30524,
	"./Golden KnightCerastes.png": 62345,
	"./GreaDraco Claw.png": 60502,
	"./GreaDraco Horn.png": 42440,
	"./GreaMaiden's Dragonblade.png": 29147,
	"./GrimnirLupercalia.png": 39029,
	"./GrimnirVortex of the Void.png": 97189,
	"./GunslingerNebuchad.png": 26543,
	"./GwynneBlue Lightning.png": 87295,
	"./HallessenaRindcleaver.png": 9046,
	"./HallessenaSoul Eater.png": 28057,
	"./HallessenaSpirit Seeker.png": 29059,
	"./Halluel and MalluelEternal Signature.png": 77110,
	"./Halluel and MalluelSharp Letter.png": 52767,
	"./HawkeyeOliver.png": 43230,
	"./HekateAmaranthine.png": 95473,
	"./HekateLulling Flambeau.png": 31913,
	"./Helel ben ShalemBab-Bell Rendezvous.png": 93858,
	"./Helel ben ShalemBab-el-Mandeb.png": 31663,
	"./Helel ben ShalemZodiaco Vitae.png": 2202,
	"./HelesCrystal Luin.png": 96920,
	"./HelesDeirdre's Symbol.png": 35125,
	"./HelesLuin.png": 38530,
	"./HerjaGreat Spear.png": 95,
	"./HermitKeraunos.png": 48252,
	"./Holy SaberSkofnung.png": 84583,
	"./HorusWas-Scepter of Horus.png": 18080,
	"./IatromantisOuranosphaira Ravdos.png": 19941,
	"./IcarusDreadful Flamesword.png": 18673,
	"./IllnottBlockbuster.png": 66513,
	"./IllnottBubble Sketcher.png": 90250,
	"./IllnottMystic Spray Gun.png": 97675,
	"./IlsaArjunan Bow.png": 29953,
	"./IlsaGandiva.png": 92944,
	"./IlsaTakeminakata.png": 85383,
	"./IlsaWhite Peony Pouch.png": 77737,
	"./IndalaSerpentius.png": 46166,
	"./IoGambanteinn.png": 6791,
	"./IoSunflower Wand.png": 61218,
	"./IppatsuUnparalleled Chopsticks.png": 31333,
	"./IsaacPlasma Slicer.png": 29680,
	"./IzmirAuriculata Bow.png": 28535,
	"./IzmirFrostbite.png": 43520,
	"./IzmirNagelring.png": 59171,
	"./Jack RakanO Iros Meta Chilion Prosopon.png": 8038,
	"./JamilArijwani.png": 41185,
	"./JasmineHerb Basket.png": 69317,
	"./Jeanne d'ArcCaladbolg.png": 45004,
	"./Jeanne d'ArcDisparia.png": 130,
	"./Jeanne d'ArcMystique.png": 64878,
	"./Jeanne d'ArcOrleans Standard.png": 21708,
	"./Jeanne d'ArcSacred Standard.png": 39498,
	"./JessicaMidnight Radiance.png": 60616,
	"./JessicaRaffiniert Arquebus.png": 10375,
	"./JinSoshu Masamune.png": 32121,
	"./JulietCapulet's Oath.png": 35890,
	"./JulietOphelia.png": 98276,
	"./JuriYoung Champion's Kilij.png": 73527,
	"./KaguyaKaguya's Folding Fan.png": 58983,
	"./KatalinaMurgleis.png": 8032,
	"./KengoUnsigned Kaneshige.png": 76295,
	"./KoluluMuch Ado.png": 95738,
	"./KoluluOffbeat.png": 36280,
	"./KoluluVagabond.png": 99255,
	"./KorwaBell of Happy Endings.png": 12089,
	"./KorwaExuberant Lance.png": 53618,
	"./KorwaWing of the Pure.png": 24980,
	"./KouJuzumaru.png": 27051,
	"./KumbhiraPorculius.png": 62066,
	"./KumbhiraTwelfth Vertex of the Passel.png": 39484,
	"./LadivaHeartbeat Mitten.png": 14925,
	"./LadivaRainbow Hand.png": 6935,
	"./Lady GreyDistant Requiem.png": 55557,
	"./Lady GreyUkonvasara.png": 82487,
	"./Lady Katapillar and ViraMetal Hand.png": 215,
	"./LagunaDreadlance.png": 91070,
	"./LamrettaHeart of a Songbird.png": 87907,
	"./Lancelot and VaneFeendrache Pennant.png": 23531,
	"./LancelotHeiliges Schwert.png": 47101,
	"./LancelotHoarfrost Blade Persius.png": 41300,
	"./LancelotKnight of Ice.png": 3540,
	"./LaviritaGold Beak.png": 61008,
	"./LeciaCommander's Sidearm.png": 89294,
	"./LeciaReunion.png": 155,
	"./LeciaSky Vacation.png": 61279,
	"./LennahFar Away.png": 83104,
	"./LennahMerveilleux.png": 30129,
	"./LeonaYahata's Naginata.png": 70989,
	"./Levin SistersLevin Shooter.png": 18392,
	"./LichPain and Suffering.png": 51225,
	"./LichToothache and Suffering.png": 71674,
	"./LileleMelodic Sphere.png": 67362,
	"./LileleSparkle Beat Vol. 29.png": 3088,
	"./LilyFrigorific Summer Parasol.png": 21952,
	"./LilyIce Crystal Staff.png": 3816,
	"./LilySaintly Crystal.png": 28701,
	"./LobeliaClapotis Douleur.png": 59024,
	"./LowainDom Party-On.png": 42829,
	"./Lu WohImperious Fury.png": 62939,
	"./Lu WohLu Woh Float.png": 61531,
	"./LuchadorChampionship Belt.png": 38435,
	"./LucioDayspring.png": 13924,
	"./LucioEden.png": 431,
	"./LuciusAlabaster Zenith.png": 94969,
	"./LumberjackRip Van Winkle.png": 22135,
	"./LumberjackTall-Tale Teller.png": 78375,
	"./LunaluInto the Sunset.png": 88495,
	"./LunaluRuling Pen.png": 57708,
	"./Macula MariusFroststar Staff.png": 25717,
	"./MagisaHoly Night Scepter.png": 24781,
	"./MagisaIllusion Scepter.png": 22392,
	"./MagisaPlumeria Scepter.png": 94568,
	"./MagusBeyond Demise.png": 87894,
	"./MahiraGallinarius.png": 64268,
	"./MahiraTenth Crest of the Clutch.png": 73728,
	"./MahiraTenth Crow of the Clutch.png": 48414,
	"./MakuraFourth Fork of the Fluffle.png": 71616,
	"./MakuraLeporidius.png": 12576,
	"./MaleagantUralter Nagel.png": 88349,
	"./ManadiverCometa Sica.png": 37159,
	"./ManamelDelightful Dolce.png": 60397,
	"./ManamelSweet Surprise.png": 66201,
	"./MarquiaresGridarvor.png": 21701,
	"./MarsBlazing Corseque.png": 25826,
	"./MaryJolly Starcracker.png": 32687,
	"./MasqueradeRudolfina.png": 22675,
	"./MedusaBloodwrought Coral.png": 22391,
	"./MedusaEuripides.png": 76300,
	"./MedusaMedusiana Floatie.png": 78599,
	"./MedusaMedusiana Staff.png": 25465,
	"./Meg and MariMarriage Ring.png": 2822,
	"./MegUrsula Glove.png": 88763,
	"./MelissabelleSplit End.png": 70652,
	"./MelissabelleSword on the Cob.png": 37364,
	"./MelleauVassago.png": 29386,
	"./MeteonRay Gun.png": 80511,
	"./MeteraAetherial Bow.png": 11830,
	"./MeteraAetherial Marine.png": 46098,
	"./MeteraPinkie Needle.png": 77026,
	"./MeteraRoseate Aetherial Bow.png": 66561,
	"./MichaelCrimson Scale.png": 4953,
	"./Milleore and Sahli LaoAcid Bolt Shooter.png": 87208,
	"./MimlemelMy Little Mim.png": 43968,
	"./Mireille and RisetteInnocent Doll.png": 64880,
	"./MirinShunran Shin'uchi.png": 18815,
	"./MirinSnowbane.png": 13497,
	"./MirinVivid Verdure.png": 52803,
	"./MishraWoodland Prayer.png": 47236,
	"./MonikaLovely Ace.png": 76014,
	"./MonikaMarine Ace.png": 40261,
	"./MonikaSky Ace.png": 79670,
	"./MonkKanabo.png": 25794,
	"./MonkRinged Armguards.png": 13777,
	"./MorrignaTrí Bandia.png": 85628,
	"./Ms. MirandaCharming Broom.png": 59423,
	"./MugenKerak.png": 923,
	"./MugenNioh.png": 85115,
	"./MysticKapilavastu.png": 24435,
	"./NaoiseBelfast.png": 43927,
	"./NaoiseConifer.png": 80648,
	"./NaoiseHeavenly Fawn Bow.png": 29184,
	"./NarmayaBlade of Purification.png": 56252,
	"./NarmayaEvanescence.png": 71474,
	"./NarmayaOnikiri Yasutsuna.png": 57574,
	"./NarmayaRaikiri.png": 41079,
	"./NarmayaVenustas.png": 7191,
	"./NectarHonekui.png": 83241,
	"./NectarRaijodo.png": 40246,
	"./NehanBlazing Rakan.png": 36983,
	"./NehanRadiant Rinne.png": 36112,
	"./NekomancerLunatic Broom.png": 1433,
	"./NemoneMettle.png": 60626,
	"./NemoneTropical Winter.png": 25142,
	"./NezahualpilliPilum.png": 45584,
	"./NezhaEmbroidered Handballs.png": 49196,
	"./NezhaFlamelance Accendo.png": 36256,
	"./NicholasGigante Bisector.png": 86194,
	"./NicholasGigante Slicer.png": 61959,
	"./NierPassion Parasol.png": 62580,
	"./NighthoundMaverick.png": 89693,
	"./NinjaMuramasa.png": 65454,
	"./NiyonNine-Realm Harp.png": 40073,
	"./NoaIvory Ark.png": 52384,
	"./NoaOrnamented Paddle.png": 4998,
	"./NoireIncomplete Polarsector.png": 84546,
	"./NoveiCorde Azzurre.png": 30546,
	"./OgreHellion Gauntlet.png": 12125,
	"./OliviaDuskwing Staff.png": 59283,
	"./OliviaFallen Sword.png": 79462,
	"./OnmyojiOnmyoji]s Reito.png": 65456,
	"./OrchidIn Full Whisker.png": 7279,
	"./OrchidParazonium.png": 58762,
	"./OrologiaCausality Driver.png": 19622,
	"./PaladinRoyal Deliverance.png": 96345,
	"./ParisDignita del Conte.png": 84690,
	"./PayilaDracosius.png": 80666,
	"./PengyHard Knuckle.png": 6844,
	"./PercivalAntwerp.png": 36450,
	"./PercivalLohengrin.png": 72761,
	"./PercivalLord of Flames.png": 64623,
	"./PercivalWalthari.png": 51585,
	"./PetraHeaven's Cloud.png": 64421,
	"./PholiaFugaku Vista Bow.png": 95790,
	"./PholiaTaisai Spirit Bow.png": 49010,
	"./PoseidonAtlantis.png": 56290,
	"./PredatorPredator Claw.png": 76132,
	"./RackamBenedia.png": 39770,
	"./RagazzoCrimson Stinger.png": 16422,
	"./RagazzoSole Intenso.png": 63900,
	"./RandallBon Joie.png": 77219,
	"./RaphaelGalgalim of Gales.png": 39957,
	"./RaziaGae Derg.png": 29823,
	"./RazielAertire.png": 80202,
	"./ReiSunya.png": 38365,
	"./ReinhardtzarFist of Destruction.png": 32678,
	"./Relic BusterPrototype Reboot.png": 59580,
	"./Relic BusterSelene.png": 18483,
	"./RichardRoyal Straight Flush.png": 71903,
	"./Rising ForceHelmholtz.png": 10215,
	"./RobertinaNastro Viola.png": 37867,
	"./Robin HoodSherwood Bow.png": 39956,
	"./RobomiRailgun.png": 30093,
	"./RomeoMontague's Oath.png": 90141,
	"./RosamiaOfficial's Jitte.png": 55228,
	"./RosamiaTwin Helix.png": 93119,
	"./RosettaLove Eternal.png": 92324,
	"./RosettaMidnight Rose.png": 53078,
	"./RosettaRosen Maiden.png": 94052,
	"./RosettaThorny Rose.png": 15814,
	"./RuneslayerTetrastreamer.png": 47470,
	"./SabrinaGuardian of Radlith.png": 89451,
	"./SageHallowed Pilgrimage.png": 93610,
	"./SamuraiMurakumo.png": 46550,
	"./SandalphonAin Soph.png": 98777,
	"./SandalphonEfes.png": 55654,
	"./SandalphonNostalgic Coffee Jelly.png": 77845,
	"./SandalphonWorld Ender.png": 71785,
	"./SaraEon.png": 56942,
	"./SaraSandcastle Song-Lume.png": 33059,
	"./SarunanKalaurops.png": 10631,
	"./SarunanSealed Claustrum.png": 86205,
	"./SatoSubekuri Gauntlet.png": 82666,
	"./SatyrDaodao Fu.png": 20817,
	"./SatyrSeilenos.png": 43988,
	"./SatyrSikinnis.png": 28988,
	"./ScathachaDeirdre's Claws.png": 93438,
	"./ScathachaDeirdre's Heart.png": 89950,
	"./SelfiraCythara Anglica.png": 30054,
	"./SenGalactic Impact.png": 41213,
	"./SenThe Hand That Scritches.png": 16950,
	"./SeofonPrismatic Trientalis.png": 72556,
	"./SeofonSeven-Star Sword.png": 42514,
	"./SeoxSix-Ruin Fist.png": 57277,
	"./SeruelBrand of Binding Oath.png": 41198,
	"./SeruelHrotti.png": 79655,
	"./SeruelMidsummer's Repose.png": 40088,
	"./Setsuna SakurazakiSica Shishikushiro.png": 33523,
	"./SevastienEpee d'Autrefois.png": 64703,
	"./SevilbarraSou-ou Momijimaru.png": 4596,
	"./ShionBonsai Blade.png": 93248,
	"./ShionEvening Floral Shower.png": 17018,
	"./ShionGoriki-maru Revised.png": 48105,
	"./ShitoriIridescent Bow.png": 90387,
	"./ShivaImpossible Diagram.png": 13552,
	"./ShivaPurifying Thunderbolt.png": 83586,
	"./ShoDestiny Knuckles.png": 57421,
	"./ShukraFelinovus.png": 52928,
	"./ShuraTeiwaz.png": 58684,
	"./SidewinderRosenbogen.png": 17833,
	"./SiegfriedAscalon.png": 38684,
	"./SiegfriedBlack Dragon's Maw.png": 66850,
	"./SiegfriedBlack Dragonslayer Sword.png": 12356,
	"./SiegfriedRavening Harpoon.png": 80380,
	"./SiegfriedSinensis.png": 79437,
	"./SilvaBeach-Camouflage Vlisragna.png": 20195,
	"./SilvaFull Metal Recoil.png": 48320,
	"./SilvaPartly Powerful Popgun.png": 88729,
	"./SilvaVlisragna.png": 60587,
	"./Skull and BalurgaJackknife.png": 72309,
	"./SocietteBlushing Blossom Pin.png": 2369,
	"./SocietteCardinal Spear.png": 88282,
	"./SocietteScarlet Vane.png": 52519,
	"./SoldierJohn Doe.png": 67328,
	"./SophiaOcean Harp.png": 78848,
	"./SophiaVertrauen.png": 98279,
	"./SorizWyrmtiger Claw.png": 21193,
	"./SpartanGuardian's Xiphos.png": 60104,
	"./SpinnahSpin Blade V2.png": 34536,
	"./Stan and AlizaGolden Dragon.png": 51229,
	"./Street KingDiadem Moulinet.png": 32778,
	"./SturmIndutiae.png": 73867,
	"./SturmIxaba.png": 30273,
	"./SturmProelium.png": 80589,
	"./SuiFirefly's Light.png": 90611,
	"./SuperstarLangeleik.png": 67862,
	"./SuteraAurora Bow.png": 40583,
	"./Sword MasterAschallon.png": 88989,
	"./SylphLa Sylphide.png": 50362,
	"./TabinaHand Axe.png": 2507,
	"./TabinaTahar Masala.png": 14621,
	"./TanyaGandring.png": 1366,
	"./TeenaTropical Fairy.png": 98191,
	"./TefnutDardur.png": 25177,
	"./ThereseTanzanite Blade.png": 54253,
	"./ThereseTanzanite Duellum.png": 3243,
	"./ThreoThree-Tiger Axe.png": 98273,
	"./TiamatTiamat Bolt Prime.png": 577,
	"./TienTen-Wolf Gun.png": 44853,
	"./TikohLancet.png": 543,
	"./TikohSummer Healing.png": 35009,
	"./TikohSyringe or Treat.png": 96418,
	"./TormentorDevil's Finger.png": 10170,
	"./TroueReveiller.png": 63140,
	"./TsubasaTwo-by-Four.png": 93973,
	"./TsukuyomiNightgaze Gate.png": 63821,
	"./TweyenShimmering Bloom.png": 4935,
	"./TweyenTwo-Crown Bow.png": 94877,
	"./TyraBuddysaurus Rex.png": 88379,
	"./Ultimate FridayFRIED Spear.png": 54946,
	"./UrielPillardriver.png": 53826,
	"./UtsusemiOrnate Paper Pinwheel.png": 60117,
	"./VajraCanisius.png": 87042,
	"./VajraEleventh Fang of the Pack.png": 39139,
	"./ValkyrieRomulus Spear.png": 72938,
	"./VaneBlossom Axe.png": 70394,
	"./VaneCreepy Claws.png": 17261,
	"./VaneSwan.png": 11546,
	"./Vania and MalindaPlushie Pal.png": 37620,
	"./VaniaAzoth.png": 90338,
	"./VaniaFlowering Twilight.png": 4469,
	"./VaseragaBeach Grynoth.png": 92033,
	"./VaseragaGrynoth Demiclone.png": 72054,
	"./VaseragaMistilteinn.png": 84051,
	"./VaseragaWurtzite Scythe.png": 633,
	"./VeightBloody Scar.png": 28148,
	"./VeightCamazotz.png": 74551,
	"./VikalaFirst Fling of the Mischief.png": 20061,
	"./VikalaFirst Fright of the Mischief.png": 54383,
	"./VikalaFirst Tail of the Mischief.png": 83353,
	"./VikalaRodentius.png": 68940,
	"./VikingNorden Labrys.png": 49604,
	"./ViraAnother Sky.png": 93095,
	"./ViraArcane Rouge.png": 74397,
	"./ViraCertificus.png": 59006,
	"./ViraDeep Desire.png": 44725,
	"./ViraLyst Sin.png": 68323,
	"./VolennaAmyna Xiphos.png": 87847,
	"./WamdusCalamitous Aquashade.png": 29193,
	"./WamdusWamdus Santa.png": 75390,
	"./WarlockDemonic Longstaff.png": 30841,
	"./Weapon MasterAvenger.png": 68661,
	"./WillBlade of Duality.png": 58390,
	"./WilnasFirestorm Scythe.png": 88690,
	"./WilnasWilnas-o'-Lantern.png": 12477,
	"./Wulf and RenieMaster Key.png": 91682,
	"./YaiaSpecial Fried Rice.png": 45107,
	"./YamatoKusanagi.png": 45253,
	"./YatimaRubea Stiria.png": 7641,
	"./YggdrasilBella Aeterna.png": 92695,
	"./YggdrasilPetit Bouquet de Fleurs.png": 95794,
	"./YggdrasilSanctolia.png": 30163,
	"./YngwieC'est la Vie.png": 14487,
	"./YngwieMeteora.png": 97508,
	"./YodarhaFudo-Kuniyuki.png": 29697,
	"./YodarhaTrue Tiger's Bane.png": 14684,
	"./YouIndigo Flame Stinger.png": 96561,
	"./Yuel and SocietteScarlet Sapphire.png": 33439,
	"./YuelCrimson Sapphire.png": 43687,
	"./YuelIzayoi.png": 34575,
	"./YuelScarlet Crest Axe.png": 82637,
	"./YuelSennen Goji.png": 76008,
	"./YuisisGangsta Knife.png": 85665,
	"./YuisisYyrkoon.png": 28234,
	"./YuniHarmonia.png": 78283,
	"./YuniNox Meteorum.png": 70035,
	"./YuriusReturner Staff.png": 93229,
	"./YuriusTentacular Javelin.png": 592,
	"./ZahlhamelinaBitternote Sun.png": 80855,
	"./ZahlhamelinaStarblaze Rings.png": 97806,
	"./ZehekMiming's Baselard.png": 40167,
	"./Zeta and VaseragaEnchanted Broomstick.png": 56219,
	"./ZetaArvess Demiclone.png": 33533,
	"./ZetaBrionac.png": 15289,
	"./ZetaCletine.png": 71503,
	"./ZetaOverrider.png": 31761,
	"./ZetaSunspot Spear.png": 60006,
	"./ZooeyCute Ribbon.png": 14720,
	"./ZooeyEquilibrium Tannenwand.png": 69533,
	"./ZooeyRuler of Fate.png": 15024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81697;